export default __webpack_public_path__ + "alberta-stdcareproposal.c23b6ca182c96d2ca9b7.svg";